export const QUERY_PARAMS_SIGN = '?';
